/* import __COLOCATED_TEMPLATE__ from './confirm-resolution.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    step: $TSFixMe;
    isReadOnly: boolean;
    toggleConfirmResolution: () => void;
    shouldShowMessengerSettings: boolean;
  };
}

export default class ConfirmResolution extends Component<Signature> {
  @service declare router: RouterService;

  get preventRepliesLink() {
    return this.router.urlFor('apps.app.settings.channels.messenger.general', this.args.step.app, {
      queryParams: {
        section: 'prevent-replies',
      },
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::Sections::ConfirmResolution': typeof ConfirmResolution;
  }
}
